import { flattenFilters, QueryParamsEnum, mapToFilterCriteria, } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function filtersUpdatedRoute({ product, filters }) {
    const paramManager = new QueryParamManager(router.currentRoute() || '/', router.currentParams());
    paramManager.removeMultiple([QueryParamsEnum.HOTELFILTERS, QueryParamsEnum.FLIGHTFILTERS]);
    paramManager.addMultiple(flattenFilters(product, filters));
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function filtersUpdatedRouting({ product, filterGroups }) {
    router.push({ product, filters: mapToFilterCriteria(filterGroups) }, filtersUpdatedRoute);
}
